import {inject, IReactComponent} from 'mobx-react';
import {WifiAnalyzerFilter} from './WifiAnalyzerFilter';

const mapStoresToProps = (stores: Record<string, any>) => {
    const localizationService = stores.inviteStore?.localizationService;
    return {
        ctrl: stores.inviteStore?.wifiAnalyzerFilterController,
        translate: localizationService?.translate.bind(localizationService)
    };
};

const WifiAnalyzerFilterComponent = inject(mapStoresToProps)(WifiAnalyzerFilter) as IReactComponent;

export default WifiAnalyzerFilterComponent;
